(() => {
	document.querySelectorAll('.show-data-speakers').forEach(button => {
    button.addEventListener('click', function() {
		$('#modalName').html($(this).data('name'));
		$('#modalTitle').html($(this).data('title'));
		$('#modalOrganisation').html($(this).data('organisation'));
		$('#modalDesc').html($(this).data('desc'));
		$('#modalImage').css('background-image', 'url(' + $(this).data('image') + ')');
		document.getElementById('modal-speakers').classList.add('is-active');
		$('#modalEventDetails').html($(this).data('event_details'));
		if(($(this).data('event_details')) === ""){
			$('#dvEventDetails').addClass("s-none");
		}else{
			$('#dvEventDetails').removeClass("s-none");
		}
    });
  });
})();
